<template>
  <div v-if="!front_page" class="catalog-title">{{ catalogTitle }}</div>
  <div class="filters-button-wrapper">
    <div id="study-filters-button" class="filters-button">Фільтр</div>
  </div>
  <div id="study-filters" class="filters-wrapper clearfix">
    <div class="mobile-bg">
      <div class="mobile-scroll">
        <i class="close-button icon icon-close"></i>
        <div v-if="trends.length" class="filters">
          <a v-on:click.stop.prevent="resetTrends" :href="getBaseStudyUrl()" :class="{active: (currentTrends.length == 0)}" class="filter-item">{{ text.all_trends }}</a>
          <a v-for="trend in trends" v-bind:key="trend.id"
            :class="{active: (currentTrends.indexOf(trend.id.toString()) !== -1)}"
            :href="getBaseStudyUrl() + '?trend=' + trend.id"
            v-on:click.stop.prevent="updateTrends(trend.id)"
            class="filter-item"
          >
            {{ trend.title }}
          </a>
        </div>
        <div class="close-inline-button">Показати</div>
      </div>
    </div>
  </div>
  <div class="study-items">
    <div class="study-item clearfix" v-for="item in studyItems" v-bind:key="item.id">
      <div v-if="item.label" :class="{'item-label-new': (item.label == 'new')}" class="item-label">{{ item.labelName }}</div>
      <a class="item-image-link" :href="item.path"><img class="item-image" :src="item.image" /></a>
      <div class="desktop">
        <div class="item-title"><a :href="item.path">{{ item.title }}</a></div>
        <div class="item-price">{{ item.price }} грн</div>
        <div class="item-footer">
          <div v-if="item.showDate" class="item-date-begin"><i class="icon icon-calendar"></i>Старт {{ item.dateBegin }}</div>
          <div v-if="item.city.length" class="item-city"><i class="icon icon-pin"></i>{{ text.m }} {{ item.city }}</div>
          <a v-if="item.payment" class="item-register" :href="item.path">{{ text.buy }}</a>
          <a v-else class="item-register" :href="item.path">{{ text.register }}</a>
        </div>
      </div>
      <div class="mobile">
        <div class="item-footer clearfix">
          <div v-if="item.showDate" class="item-date-begin"><i class="icon icon-calendar"></i>Старт {{ item.dateBegin }}</div>
          <div v-if="item.city.length" class="item-city"><i class="icon icon-pin"></i>{{ text.m }} {{ item.city }}</div>
        </div>
        <div class="item-title"><a :href="item.path">{{ item.title }}</a></div>
        <div class="item-price">{{ item.price }} грн</div>
        <a v-if="item.payment" class="item-register" :href="item.path">{{ text.buy }}</a>
        <a v-else class="item-register" :href="item.path">{{ text.register }}</a>
      </div>
    </div>
    <div class="more-items-wrapper">
      <div v-if="totalCount > studyItems.length" @click="loadNextPage" class="more-items-button">{{ text.show_more }}</div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import { mapMutations } from 'vuex';
import { mapGetters } from 'vuex';
import qs from 'qs';
import axios from 'axios'

export default {
  data: () => {
    return {
      is_loading: false,
      totalCount: 0,
      page: 0
    }
  },

  computed: {
    ...mapState([
      'langcode',
      'text',
      'front_page',
      'catalogTitle',
      'studyItems',
      'trends',
      'currentTrends',
      'studyUrl'
    ])
  },

  watch: {

    '$route' () {
       this.sendItemsRequest()
    },

    currentTrends: {
      deep: true,
      handler() {
        this.setStudyUrl(this.getBaseStudyUrl() + this.getTrendsQuery())
      }
    },

    studyUrl() {
      this.$router.push(this.studyUrl)
    },

    page() {
      this.sendItemsRequest()
    }

  },

  methods: {

    ...mapActions([
      'resetTrends'
    ]),

    ...mapMutations([
      'updateTrends',
      'updateStudyItems',
      'appendStudyItems',
      'setStudyUrl'
    ]),

    ...mapGetters([
      'getTrendsQuery',
      'getSelectedType',
      'getBaseStudyUrl'
    ]),

    loadNextPage() {
      if (!this.is_loading && this.totalCount > this.studyItems.length) {
        this.page++;
      }
    },

    sendItemsRequest() {
      this.is_loading = true
      let data = {
        langcode: this.langcode,
        trend: this.currentTrends,
        front: this.front_page ? 'front' : '',
        page: this.page
      }
      axios.post('/studyajax',
      qs.stringify(data),
      {
        emulateJSON: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        }
      }
      ).then((response) => {
        this.is_loading = false
        this.totalCount = response.data.totalCount
        if ( this.page ) {
          this.appendStudyItems(response.data.items)
        } else {
          this.updateStudyItems(response.data.items)
        }
      })

    },

  }

}

</script>
